import { createApiClientBindings } from '../core/client';
import type { paths } from '../__generated__/access/database.ts';
import type { Client } from 'openapi-fetch';

export type { ClientOptions, ServerClientConfig } from '../core/client';

const bindings = createApiClientBindings<paths>('__trAccessBrowserClient');

export type ApiClient = Client<paths, 'application/json'>;

export const { createServerApiClient, createApiClient, getApiClient } = bindings;
